import {Component, inject} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {DialogRef} from '@angular/cdk/dialog';

@Component({
  selector: 'app-session-timeout',
  imports: [
    TranslatePipe,
  ],
  templateUrl: './session-timeout.component.html',
  styleUrl: './session-timeout.component.css'
})
export class SessionTimeoutComponent {

  dialogRef = inject(DialogRef);

  close() {
    this.dialogRef.close({extend: true});
  }

}
